module.exports = __webpack_public_path__ + "static/media/pic_banner_plans.2aa87ae5.jpg";